import { GET_SEO_DATA } from '@graphql/article/article.query'
import queryGraphql from '@shared/components/queryGraphql'
import React from 'react'
import PropTypes from 'prop-types'
import Layout from '@shared/components/layout'
import { setPreviewMode } from '@shared-submodule/sm-libs/menu'
import ArticleDetail from '@shared/components/articleDetailMoble'
import ArticleContent from '@shared/components/articleDetailMoble/articleContent'
import useWindowSize from '@shared/hooks/windowSize'
import PageNotFound from '@shared/components/pageNotFound'
import FantasyArticleDetail from '@shared/components/fantasyArticleDetail'
import FantasyArticleContent from '@shared/components/articleDetail/fantasyArticleContent'
import CMSContent from '@shared/components/cmsContent'
import { GRAPHQL_URL } from '@shared-submodule/sm-constants'
import HallOfFameDetailPage from '@pages/formula1-racing/hall-of-fame/drivers/[slug]'
const MemoizedLayout = React.memo(Layout)
const MemoizedArticleDetail = React.memo(ArticleDetail)

// import PageError from '@shared/components/pageError'

function MobileArticle({ seoData, article, cmsData, liveArticle, currentSeriesData, playingXI, match, hallOfFameDetailData }) {
  const [width] = useWindowSize()
  setPreviewMode(true)

  if ((width || 0) >= 1024) {
    return (
      <div className="mt-5">
        <PageNotFound />
      </div>
    )
  } else {
    return (
      <MemoizedLayout data={{ oSeo: { sRobots: 'noindex' } }}>
        {seoData?.eType === 'ar' && (
          <MemoizedArticleDetail seoData={seoData} article={article} liveArticle={liveArticle} type="article">
            <ArticleContent article={article} liveArticle={liveArticle} />
          </MemoizedArticleDetail>
        )}
        {seoData?.eType === 'fa' && (
          <FantasyArticleDetail isMobile isPreviewMode article={article} currentSeriesData={currentSeriesData}>
            <FantasyArticleContent data={article} playingXI={playingXI} match={match} seriesData={currentSeriesData} isMobile={true} />
          </FantasyArticleDetail>
        )}
        {seoData?.eType === 'p' && seoData?.sSlug?.includes('formula1-racing/hall-of-fame/drivers') && (
          <HallOfFameDetailPage hallOfFameDetailData={hallOfFameDetailData} seo={seoData} removeAds={true} />
        )}
        {seoData?.eType === 'cms' && <CMSContent isMobile data={cmsData} seoData={seoData} />}
      </MemoizedLayout>
    )
  }
}
// }
MobileArticle.propTypes = {
  seoData: PropTypes.object,
  hallOfFameDetailData: PropTypes.object,
  cmsData: PropTypes.object,
  article: PropTypes.object,
  liveArticle: PropTypes.object,
  currentSeriesData: PropTypes.object,
  playingXI: PropTypes.object,
  match: PropTypes.object
}
export default MobileArticle

export async function getServerSideProps({ query, res, resolvedUrl }) {
  try {
    const slug = query?.slug?.join('/')
    const { data: seo } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: slug } })
    if (seo?.getSeoData?.eType === 'cms') {
      // Cms pages
      res.setHeader('Cache-Control', 'public, max-age=1200')
      const GET_CMS_PAGE = (await import('@graphql/cms/cms.query')).GET_CMS_PAGE
      const { data: cmsData } = await queryGraphql(GET_CMS_PAGE, { input: { _id: seo?.getSeoData?.iId } })
      return {
        props: {
          seoData: seo?.getSeoData,
          cmsData: cmsData
        }
      }
    } else if (seo?.getSeoData?.eType === 'p' && slug?.includes('formula1-racing/hall-of-fame/drivers')) {
      const baseUrl = GRAPHQL_URL.replace(/\/graphql$/, '')
      const teamDetailResponse = await fetch(`${baseUrl}/api/global-widget/f1/hall-of-fame/driver/${seo?.getSeoData?.iId}`, {
        method: 'GET',
        headers: {
          'x-api-key': process.env.REACT_APP_API_KEY,
          'Content-Type': 'application/json'
        }
      })
      const hallOfFameDetailData = await teamDetailResponse.json()

      return {
        props: {
          hallOfFameDetailData: hallOfFameDetailData || {},
          seoData: seo?.getSeoData || {},
          slug: slug
        }
      }
    } else {
      const GET_ARTICLE_DETAILS_DATA = (await import('@graphql/article/article.query')).GET_ARTICLE_DETAILS_DATA
      const { data } = await queryGraphql(GET_ARTICLE_DETAILS_DATA, { input: { _id: seo?.getSeoData?.iId } })
      const liveArticle = {}
      if (data.getArticleFront?.iEventId) {
        const { getLiveArticleData } = await import('@shared-submodule/sm-libs/live-blog')
        const { oLiveArticleContent, oLiveArticleAmpContent, aLiveArticleList, oLiveArticleEvent } = await getLiveArticleData(
          data?.getArticleFront
        )
        liveArticle.oLiveArticleContent = oLiveArticleContent
        liveArticle.oLiveArticleAmpContent = oLiveArticleAmpContent
        liveArticle.aLiveArticleList = aLiveArticleList
        liveArticle.oLiveArticleEvent = oLiveArticleEvent || {}
      }
      return {
        props: {
          seoData: seo?.getSeoData || {},
          article: data?.getArticleFront || {},
          liveArticle
        }
      }
    }
  } catch (e) {
    console.log({ e })
    res.setHeader('Cache-Control', 'no-cache')
    const handleApiError = (await import('@shared-submodule/utils')).handleApiError
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
